var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_vm._v(" This feature not yet available "),_c('ApiPostFeedback',{attrs:{"post-state":_vm.postState}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }